<template>
  <div class="item">
    <div class="item_title">
      {{ localStorage.translations.pages['setting-personal_area'].sections['navyki'] }}
    </div>
    <div class="item_data" v-if="!skills">
      <span class="data">{{ '-' }}</span>
    </div>
    <div class="item_data" v-for="(i, index) in skills" :key="index">
      <span class="data">{{ i.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkillsPdf',
  props: ['skills'],
  components: {},
  data: () => ({}),
  watch: {},
}
</script>

<style lang="scss" scoped>
.item {
  &_title {
    border: 1px solid #dbdbdb;
    padding: 8px 10px;
    color: #2c2c2c;
    font-size: 16px;
    display: grid;
    grid-template-columns: max-content max-content;
    justify-content: space-between;
    font-weight: bold;
  }
  &_data {
    min-height: 36px;
    padding: 2px 10px;
    font-weight: normal;
    font-size: 12.5px;
    display: grid;
    justify-content: space-between;
    align-items: center;
    .data {
      color: #2c2c2c;
    }
    &:not(:last-of-type) {
      border-bottom: 1px solid #dbdbdb;
    }
  }
}
</style>
